import type { EditorConfig } from "@prismicio/editor-fields"
import { captureException } from "@sentry/react"

import { headerHeight } from "../document/documentLayout"
import { env } from "./env"
import { getBaseUrl, getRepositoryName } from "./routing"
import { baseUrl as coreApiBaseUrl } from "./services/core"
import { trackEditorEvent } from "./tracking"

export const staticEditorConfig = {
  embedApiEndpoint: env.EMBED_API_ENDPOINT,
  unsplashApiBaseUrl: env.UNSPLASH_API_BASE_URL,
  mediaLibrary: true,
  assetsApiBaseUrl: env.ASSETS_API_BASE_URL,
  repository: getRepositoryName(),
  searchDocuments: true,
  documentSearchBaseUrl: env.DOCUMENT_SEARCH_BASE_URL,
  uidField: true,
  coreApiBaseUrl,
  customTypesApiBaseUrl: env.CUSTOM_TYPES_API_BASE_URL,
  authStrategy: env.PAGE_BUILDER_AUTH_STRATEGY,
  baseUrl: getBaseUrl(),
  integrationFields: true,
  integrationFieldsApiBaseUrl: env.INTEGRATION_FIELDS_API_BASE_URL,
  scrollOffsetTop: headerHeight,
  userServiceBaseUrl: env.USER_SERVICE_BASE_URL,

  onAnalyticsEvent: trackEditorEvent,
  onTrackError: captureException
} satisfies Partial<EditorConfig>
